export const getMonthEnglish = (month: number) => {
  switch (month) {
    case 1:
      return 'January';
    case 2:
      return 'February ';
    case 3:
      return 'March ';
    case 4:
      return 'April ';
    case 5:
      return 'May ';
    case 6:
      return 'June';
    case 7:
      return 'July';
    case 8:
      return 'August';
    case 9:
      return 'September';
    case 10:
      return 'October';
    case 11:
      return 'November';
    case 12:
      return 'December';
    default:
      return 'N/A';
  }
};

export const getPrettyDayTime = (date: Date) => {
  const min = date.getMinutes();
  const hour = date.getHours();
  let minString = min.toString();
  let hourString = hour.toString();
  let dayPeriod = 'am';

  if (min < 10) {
    minString = '0' + min.toString();
  }

  if (hour > 12) {
    hourString = (hour - 12).toString();
    dayPeriod = 'pm';
  } else if (hour === 0) {
    hourString = (12).toString();
  }

  return (
    hourString +
    ':' +
    minString +
    dayPeriod +
    ' ' +
    date.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2]
  );
};

export const getPrettyDayTimeUTC = (date: Date) => {
  const min = date.getUTCMinutes();
  const hour = date.getUTCHours();
  let minString = min.toString();
  let hourString = hour.toString();
  let dayPeriod = 'am';

  if (min < 10) {
    minString = '0' + min.toString();
  }

  if (hour > 12) {
    hourString = (hour - 12).toString();
    dayPeriod = 'pm';
  } else if (hour === 0) {
    hourString = (12).toString();
  }

  return hourString + ':' + minString + dayPeriod + ' UTC';
};

export const getTextFieldDateFormat = (date: Date) => {
  const year = date.getFullYear().toString();
  const month =
    date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1).toString()
      : (date.getMonth() + 1).toString();
  const day =
    date.getDate() < 10
      ? '0' + date.getDate().toString()
      : date.getDate().toString();
  const hours = date.getHours().toString();
  const minutes =
    date.getMinutes() < 10
      ? '0' + date.getMinutes().toString()
      : date.getMinutes().toString();

  const newDate = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
  return newDate;
};
